// libs
import { styled } from '@nykaa/ui-components';

export const WishlistContainer = styled.div`
  width: max-content;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing80}`};
`;

export const AddToWishlistText = styled.span`
  ${({ theme }) => `margin-left: ${theme.spacing.spacing40};`};
  ${({ theme }) => theme.typography.buttonLarge};
  ${({ theme }) => `color: ${theme.colors.primary};`};
`;
